export default __webpack_public_path__ + "static/media/errorSymbol.cf3daefe.svg";